/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import UseAxios from '../../../Api/http/http';
import PropTypes from 'prop-types';
import CommonTextField from '../../../Components/TextField/textField';
import './editCategory.scss';
import FormDialog from '../../../Components/Modal/modal';
import {
  CERTIFICATION_CATEGORY,
  ADD_EDIT_RESPONSE_MESSAGES,
  CANCEL_TEXT,
  UPDATE,
  AUTHENTICATION_FAILED,
} from '../../../Constants/strings';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import {updateCategory} from '../../../Api/request/certificationCategoryMaster';


const EditCategoryForm = ({
  modalOpen,
  handleClose,
  setRows,
  selectedCategoryId,
  selectedSubCategoryId,
  selectedcategory,
  selectedSubCategory,
  isActive,
  lastUpdatedBy,
}) => {
  const [autoFocus, setAutoFocus] = useState(false);
  const [categoryNameValue, setCategoryNameValue] = useState(selectedcategory);
  const [subCategoryValue, setSubCategoryValue] = useState(selectedSubCategory);
  const [categoryError, setCategoryError] = useState('');
  const [subCategoryError, setSubCategoryError] = useState('');
  const { snackbarOpen } = useSnackbar();

  useEffect(() => {
    setCategoryNameValue(selectedcategory);
    setSubCategoryValue(selectedSubCategory);
  }, [selectedcategory, selectedSubCategory]);

  const handleCloseWithReset = () => {
    resetValues();
    handleClose();
  };

  const resetValues = () => {
    setCategoryError('');
    setSubCategoryError('');
    setCategoryNameValue(selectedcategory);
    setSubCategoryValue(selectedSubCategory);
  };

  const handleResponse = (response) => {
    switch (response.data.status || response.data.response.data.statusCode) {
    case 200:
      setRows(prevRows => {
        return prevRows.map(row => {
          if (row.subCategoryId === response.data.subCategoryId) {
            return {
              ...row,
              categoryName: categoryNameValue.trim(),
              subCategoryName: subCategoryValue.trim(),
            };
          } else if (row.categoryId === response.data.categoryId) {
            return {
              ...row,
              categoryName: categoryNameValue.trim(),
            };
          }
          return row;
        });
      });
      snackbarOpen(response.data.message, 'success');
      handleCloseWithReset();
      break;
    case 400:
      snackbarOpen(
        response.data.response.data.externalMessage,
        'warning',
      );
      break;
    case 401:
      snackbarOpen(AUTHENTICATION_FAILED, 'warning');
      break;
    default:
      snackbarOpen(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN, 'warning');
      handleCloseWithReset();
      break;
    }
  };

  const handleSubmit = async () => {
    const trimmedCategoryName = categoryNameValue.trim();
    const trimmedSubCategoryValue = subCategoryValue.trim();

    if (categoryError !== '' || subCategoryError !== '') {
      return;
    }
    const payload = {
      categoryId: selectedCategoryId,
      subCategoryId: selectedSubCategoryId,
      categoryName: trimmedCategoryName,
      subCategories: trimmedSubCategoryValue,
      isActive: isActive,
      lastUpdatedBy: lastUpdatedBy,
    };

    if (
      !payload.categoryName
        || !payload.subCategories
    ) {
      setCategoryError(
        !payload.categoryName
          ? CERTIFICATION_CATEGORY.REQUIRED_FILED
          : '',
      );
      setSubCategoryError(
        !payload.subCategories
          ? CERTIFICATION_CATEGORY.REQUIRED_FILED
          : '',
      );
      return;
    }

    try {
      const response = await UseAxios(updateCategory(payload));
      handleResponse(response);
      setAutoFocus(false);
    } catch (error) {
      snackbarOpen(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN, 'warning');
      handleCloseWithReset();
      console.error('Error updating category', error);
    }
  };

  const handleInputChange = (event, setValue, setError) => {
    const newValue = event.target.value;
    setValue(newValue);
    setAutoFocus(false);

    const specialCharPattern = /[^a-zA-Z0-9 ]/;

    if (specialCharPattern.test(newValue)) {
      setError(`${ADD_EDIT_RESPONSE_MESSAGES.PERFORM_CYCLE_NO_SPECIAL_CHAR}`);
    } else if (newValue.length < 3 || newValue.length > 32) {
      setError(`${CERTIFICATION_CATEGORY.NAME_MUST_BE}`);
    } else {
      setError('');
    }
  };

  const handleCategoryChange = (event) => {
    handleInputChange(event, setCategoryNameValue, setCategoryError);
  };

  const handleSubcategoryChange = (event) => {
    handleInputChange(event, setSubCategoryValue, setSubCategoryError);
  };

  return (
    <div>
      <FormDialog
        title={CERTIFICATION_CATEGORY.EDIT_CATEGORY}
        open={modalOpen}
        button1Action={handleCloseWithReset}
        dialogPaperCss="edit-cert-category-dialog-paper"
        dialogCss="edit-cert-category-dialog"
        dialogBodycontent={
          <div className="edit-cert-category-dialog-body">
            <CommonTextField
              textCss="category-name"
              label={CERTIFICATION_CATEGORY.CATEGORY}
              value={categoryNameValue}
              onChange={handleCategoryChange}
              placeholder={CERTIFICATION_CATEGORY.ENTER_CATEGORY}
              autoFocus={true}
              size="small"
              id={'edit-category-name-text'}
            />
            {categoryError && (
              <div className={'edit-cert-category-error'}>
                <small>{categoryError}</small>
              </div>
            )}
            <CommonTextField
              textCss="cert-sub-category"
              label={CERTIFICATION_CATEGORY.ADD_SUB_CATEGORY}
              value={subCategoryValue}
              onChange={handleSubcategoryChange}
              placeholder={CERTIFICATION_CATEGORY.ENTER_SUB_CATEGORY}
              autoFocus={autoFocus}
              size="small"
              id={'edit-sub-category-text'}
            />
            {subCategoryError && (
              <div className={'edit-cert-category-error'}>
                <small>{subCategoryError}</small>
              </div>
            )}
          </div>
        }
        button1={CANCEL_TEXT}
        button2={UPDATE}
        button2Action={handleSubmit}
        cancelButtonId={'edit-role-cancel-btn'}
        submitButtonId={'edit-role-submit-btn'}
      />
    </div>
  );
};

EditCategoryForm.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  selectedCategoryId: PropTypes.number,
  selectedSubCategoryId: PropTypes.number,
  selectedcategory: PropTypes.string,
  selectedSubCategory: PropTypes.string,
  isActive: PropTypes.bool,
  lastUpdatedBy: PropTypes.string,
};

export default EditCategoryForm;
